import { Mappable, Mapped } from '../../rest/decorators/mapped'
import { RestQuery } from '../../rest/utilities/rest-query'
import { UserPermission } from '../types/user-permission'
import { TwoFactorAuthenticationMethod } from './two-factor-authentication-method'

@Mapped(
  {
    first_name: { property: 'firstName' },
    last_name: { property: 'lastName' },
    sign_in_code: { property: 'signInCode' },
    twoFactorAuthenticationMethod: {
      format: TwoFactorAuthenticationMethod.create,
    },
    two_factor_is_configured: { property: 'twoFactorIsConfigured' },
    two_factor_requires_configuration: {
      property: 'twoFactorRequiresConfiguration',
    },
    can_sign_in: { property: 'canSignIn' },
    job_moved_notifications: { property: 'jobMovedNotifications' },
    is_locked: { property: 'locked' },
    breathe_identifier: { property: 'breatheID' },
    morph_type: { property: 'morphType' },
  },
  ['numericID']
)
export class User extends Mappable {
  id!: string | number
  numericID!: number
  ulid!: string
  firstName!: string | null
  lastName!: string | null
  email!: string
  phone!: string
  signInCode!: string
  twoFactorAuthenticationMethod?: TwoFactorAuthenticationMethod
  twoFactorIsConfigured?: boolean | null
  twoFactorRequiresConfiguration?: boolean | null
  canSignIn!: boolean
  stock!: boolean
  sales!: boolean
  jobMovedNotifications!: boolean
  locked!: boolean
  permissions: UserPermission[] = []
  breatheID!: string | null
  morphType!: string

  get name(): string {
    return (
      [this.firstName, this.lastName]
        .map((name) => (name ?? '').trim())
        .filter((name) => !!name)
        .join(' ') ?? 'User'
    )
  }

  hasPermission(code: string): boolean {
    return this.permissions.filter((p) => p.code === code).length > 0
  }

  static create<Data>(attrs: Data) {
    return new User().map(attrs)
  }
}

interface Filters {
  keywords?: string
  is_locked?: boolean
  exclude?: string
  sales?: boolean
  archive?: string
}

export type Ordering =
  | 'name'
  | '-name'
  | 'email'
  | '-email'
  | 'phone'
  | '-phone'
  | 'sales'
  | '-sales'

type Includes = 'permissions' | 'twoFactorAuthenticationMethod'

export class UserQuery extends RestQuery<Filters, Ordering, Includes> {}
